var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33338 7.33326H7.80672L7.62005 7.15326C8.42005 6.21993 8.83338 4.9466 8.60672 3.59326C8.29338 1.73993 6.74672 0.259929 4.88005 0.0332621C2.06005 -0.313405 -0.313282 2.05993 0.0333842 4.87993C0.260051 6.7466 1.74005 8.29326 3.59338 8.6066C4.94672 8.83326 6.22005 8.41993 7.15338 7.61993L7.33338 7.8066V8.33326L10.1667 11.1666C10.4401 11.4399 10.8867 11.4399 11.1601 11.1666C11.4334 10.8933 11.4334 10.4466 11.1601 10.1733L8.33338 7.33326ZM4.33338 7.33326C2.67338 7.33326 1.33338 5.99326 1.33338 4.33326C1.33338 2.67326 2.67338 1.33326 4.33338 1.33326C5.99338 1.33326 7.33338 2.67326 7.33338 4.33326C7.33338 5.99326 5.99338 7.33326 4.33338 7.33326Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.ccc8d43a68e445c0fc5324ed84951937.svg";
export { ForwardRef as ReactComponent };